import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiDataBase from "server";
import UseContext from "hooks/useContext";
import EmptyStateCompany from "components/emptyState";
import SectionWrapper from "pages/createMission/components/SectionWrapper";
import TemplateCard from "pages/missionTemplates/components/TemplateCard";

// Mission-creation entry point: forces the user to pick a mission template.
// The selection is stored on context (`selectedMissionTemplate`) and consumed
// by the rest of the wizard, which hydrates `data` and submits the
// `missionTemplateId` to the API.
const SelectTemplate = () => {
    const navigate = useNavigate();
    const {
        missionTemplates,
        setMissionTemplates,
        refreshMissionTemplates,
        selectedMissionTemplate,
        setSelectedMissionTemplate,
        resetTemplateData,
        companyData,
    } = UseContext();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!companyData?._id) return;
        let cancelled = false;
        setIsLoading(true);
        ApiDataBase.getMissionTemplates(
            { idCompany: companyData._id },
            (res) => {
                if (cancelled) return;
                setMissionTemplates(res?.templates || []);
                setIsLoading(false);
            },
            (err) => {
                if (cancelled) return;
                console.error(err);
                toast.error("Impossible de charger les fiches de poste");
                setIsLoading(false);
            }
        );
        return () => {
            cancelled = true;
        };
    }, [
        refreshMissionTemplates,
        setMissionTemplates,
        companyData?._id,
    ]);

    const handleCreateTemplate = () => {
        resetTemplateData();
        navigate("/missionTemplates/create");
    };

    if (!isLoading && (!missionTemplates || missionTemplates.length === 0)) {
        return (
            <EmptyStateCompany
                type={"job_post_template"}
                onAction={handleCreateTemplate}
            />
        );
    }

    return (
        <SectionWrapper
            title="Fiches de postes"
            description="Sélectionnez un modèle pour créer la mission. Les fiches inférieures au SMIC ne sont pas sélectionnables."
        >
            {isLoading ? (
                <div className="flex flex-col gap-3">
                    {[1, 2, 3].map((i) => (
                        <div
                            key={i}
                            className="h-24 bg-gray-100 rounded-xl animate-pulse"
                        />
                    ))}
                </div>
            ) : (
                <div className="flex flex-col gap-3">
                    {missionTemplates.map((template) => (
                        <TemplateCard
                            key={template._id}
                            template={template}
                            selectable
                            selected={
                                selectedMissionTemplate?._id === template._id
                            }
                            onSelect={(t) => setSelectedMissionTemplate(t)}
                        />
                    ))}
                </div>
            )}
        </SectionWrapper>
    );
};

export default SelectTemplate;
